import React from 'react';

const defaultProps = {
  condition: undefined,
};

export function If({ children, condition }) {
  if (React.Children.count(children) === 1) {
    return condition ? children : null;
  }

  return React.Children.map(children, (element) => {
    // @ts-ignore
    const { type: Component } = element || {};

    if (condition) {
      if (Component?.type === 'then') {
        return element;
      }
    } else if (Component?.type === 'else') {
      return element;
    }

    return null;
  });
}

If.defaultProps = defaultProps;

export function Then({ children }) {
  return children;
}

Then.type = 'then';

export function Else({ children }) {
  return children;
}

Else.type = 'else';

If.Then = Then;
If.Else = Else;

export default If;
